import {
  CLEAR_MCS_PLAY_BUTTON_LIST,
  GET_MCS_PLAY_BUTTON_LIST,
  GET_PLAY_BUTTON_LIST_POPULAR_SEARCHES,
} from './../constants';

const initialState = {
  contentsPlayButtonList: {},
  popularPlayButtonList: {},
};

const MCSInfo = (state = initialState, action) => {
  switch (action.type) {
    case GET_MCS_PLAY_BUTTON_LIST:
      return {
        ...state,
        contentsPlayButtonList: action.payload,
      };
    case GET_PLAY_BUTTON_LIST_POPULAR_SEARCHES:
      return {
        ...state,
        popularPlayButtonList: action.payload,
      };
    case CLEAR_MCS_PLAY_BUTTON_LIST:
      return {
        ...state,
        contentsPlayButtonList: initialState.contentsPlayButtonList
      };

    default:
      return state;
  }
};

export default MCSInfo;
